/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { BaseController } from '../../BaseController';

class EquipmentAttachmentViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, equipmentAttachmentService, waitSpinnerService, $q, $state, $stateParams, $log,
        notificationService, $mdDialog, data) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.equipmentAttachmentService = equipmentAttachmentService;
        this.$mdDialog = $mdDialog;
        this.equipmentId = data.equipmentId;
        this.$log.debug('Controller \'EquipmentAttachmentViewController\' loaded');
        // Angular Material does not support Angular $onInit hook for controllers yet
        // (see https://github.com/angular/material/issues/9259)
        // That's why it is simulated hereafter. This code shall be removed if the issue above is fixed (expected in
        // Angular Material 1.2.0)
        this.initialized = false;
        this.$onInit();
    }

    $onInit() {
        if (this.initialized) {
            this.$log.warn('EquipmentAttachmentViewController.$onInit called twice: issue 9259 may have been fixed');
        } else {
            super.$onInit();

            this.formDisabled = false;
            this.initialized = true;
        }
    }

    /**
     * Converts this form data to valid DTO (form multiparts).
     *
     * @return {Object} Form multiparts, indexed by name.
     */
    convertToDto() {
        const formData = {
            attachments: this.attachments
        }
        return formData;
    }

    save() {
        if (this.areAttachmentsValid(this.attachments)) {
            this.formDisabled = true;
            this.handleRestServiceCall(
                this.equipmentAttachmentService.createEntityWithUpload({ equipmentId: this.equipmentId }, this.convertToDto()),
                () => {
                    this.notificationService.pushMessage('ui.equipment.attachmentsadded',
                        this.configuration.NOTIFIER_LEVEL_INFO);
                    this.$mdDialog.hide(true);
                }
            ).finally(() => {
                this.formDisabled = false;
            });
        }
    }

    cancel() {
        this.$mdDialog.hide(false);
    }
}

export { EquipmentAttachmentViewController };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/equipment/component/EquipmentAttachmentView.js